import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function EnquiryDialog({ trigger, type = "enquiry", course = "", title = "Enquire Now" }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/leads", { ...form, type, course_interest: course || undefined, source: "website" });
      toast.success("Thank you! Our counselling team will contact you shortly.");
      setOpen(false);
      setForm({ name: "", phone: "", email: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="bg-navy-surface border-white/10 text-slate-200 sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-white">{title}</DialogTitle>
          {course && <p className="text-sm text-orange-400">{course}</p>}
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4" data-testid="enquiry-form">
          <div>
            <Label htmlFor="enq-name">Full Name *</Label>
            <Input id="enq-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="bg-navy-base border-white/15 text-white mt-1" data-testid="enquiry-name-input" />
          </div>
          <div>
            <Label htmlFor="enq-phone">Phone (WhatsApp preferred) *</Label>
            <Input id="enq-phone" required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })}
              className="bg-navy-base border-white/15 text-white mt-1" data-testid="enquiry-phone-input" />
          </div>
          <div>
            <Label htmlFor="enq-email">Email</Label>
            <Input id="enq-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="bg-navy-base border-white/15 text-white mt-1" data-testid="enquiry-email-input" />
          </div>
          <div>
            <Label htmlFor="enq-message">Message</Label>
            <Textarea id="enq-message" rows={3} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
              placeholder={type === "counselling" ? "Tell us your education level and career goal…" : "Any questions about this course?"}
              className="bg-navy-base border-white/15 text-white mt-1" data-testid="enquiry-message-input" />
          </div>
          <Button type="submit" disabled={submitting} className="w-full bg-orange-600 hover:bg-orange-700 text-white font-semibold transition-colors" data-testid="enquiry-submit-btn">
            {submitting ? "Submitting…" : "Submit Enquiry"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
